import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};


const DataRetentionPolicySection = () => {
    return (
        <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
            <Typography paragraph>
                WatchNod includes clear and transparent policies related to data retention and deletion to ensure user control and security.
            </Typography>

            {/* 1. Expired Plan Data Deletion */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                1. Expired Plan Data Deletion
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Retention Period:</strong> When a user’s subscription plan expires, the data associated with monitored IPs will be retained for 7 days.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Permanent Deletion:</strong> After 7 days, all such data will be permanently removed.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Irretrievability:</strong> Once deleted, the data cannot be recovered under any circumstances.
                    </Typography>
                </li>
            </ul>
            <Typography variant="body1" color="text.secondary" >
                Note: Users are advised to export or backup necessary data before the plan expiration period ends.
            </Typography>

            {/* 2. Manual Deletion of Monitoring Addresses */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                2. Manual Deletion of Monitoring Addresses
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Immediate Deletion:</strong> When a user deletes a monitored address manually, all related historical data, logs, and metrics are permanently erased.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>No Recovery:</strong> This deletion is irreversible. Users should confirm carefully before proceeding.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Impact:</strong> Deleting an address may affect analytics and reports that reference historical data.
                    </Typography>
                </li>
            </ul>
        </Box>
    );
};

export default DataRetentionPolicySection;
